import { toast } from "react-toastify";

export const errorToast = error => toast.error(error?.message || error, { autoClose: 5000 });
export const successToast = message => toast.success(message);
